import React from "react";
import { useSelector } from "react-redux";

//STYLES
import * as SectionsStyles from "./styles/sections";

//COMPONENTS
import PageNavigationButtons from "../navBar/pageNavigationButtons";

//COMPONENTS
import ContentSection from "./contentSection";

function Links(props) {
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    return (
        <div style={{ ...SectionsStyles.backgroundPicture, backgroundImage: `url('/content/mainStyle/sectionsBackgrounds/${props.image}')` }}>
            <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_blueBackground : SectionsStyles.blueBackground}>
                <PageNavigationButtons downText={"Contact Us"} upText={"Community"} />
                <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_insideContainer : SectionsStyles.insideContainer}>
                    <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_whiteCentredSection : SectionsStyles.whileCentredSection}>
                        <div style={SectionsStyles.contentContianer}>
                            <ContentSection pageID={11} nav={"links"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Links;
